module.exports = __webpack_public_path__ + "img/22.672a0a09.png";